import { APIUrls } from "../../Constants/ApiUrls";
import { AjaxService, IAPIRequest, IAPIResponse } from "../AjaxService";

// Notifiche degli allarmi su questo dispositivo (Web Push)
const PushController = {
  GetKey: async (callback?: (response: IAPIResponse) => void) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.PUSH.PUSH_KEY;
    return await AjaxService.APICall(request, callback);
  },
  Subscribe: async (subscription: any, callback?: (response: IAPIResponse) => void) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.PUSH.PUSH_SUBSCRIPTION;
    request.method = "POST";
    request.payload = subscription;
    return await AjaxService.APICall(request, callback);
  },
  Unsubscribe: async (endpoint: string, callback?: (response: IAPIResponse) => void) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.PUSH.PUSH_UNSUBSCRIBE;
    request.method = "POST";
    request.payload = { endpoint };
    return await AjaxService.APICall(request, callback);
  },
  SendTest: async (endpoint: string, callback?: (response: IAPIResponse) => void) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.PUSH.PUSH_TEST;
    request.method = "POST";
    request.payload = { endpoint };
    return await AjaxService.APICall(request, callback);
  },
};

export default PushController;
